// Module
var code = "<template bindable=\"address\"> <span>${address.street1}</span> <span if.bind=\"address.street2\">, ${address.street2}</span> <span>${address.city}, ${address.region.code} ${address.postalCode}</span> </template> ";
// Exports
module.exports = code;